import React from 'react';
import { useParams } from 'react-router-dom';
import { ItemDetail } from '../../components/ItemDetail/ItemDetail';
import BubbleContainer from 'components/BubbleContainer/BubbleContainer';
import { useUserData } from 'services/UserService';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import styles from '../../assets/jss/material-kit-react/views/profilePage';

type PickitDetailPageParams = Record<'id', string>;

const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  container: {
    ...styles.container,
    position: 'relative',
    zIndex: 3,
  },
}));

export function PickitDetailPage() {
  const { id } = useParams<PickitDetailPageParams>();
  const { data: userData } = useUserData();
  const classes = useStyles();

  if (!id) {
    return <div>Invalid pickit ID</div>;
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <ItemDetail itemId={id} type="pickit" currentUserId={userData?.id} />
        <BubbleContainer />
      </div>
    </div>
  );
}
